import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { Icon } from 'ui';
import styled from 'styled-components';

const LinkActions = styled.div`
  margin-left: 5px;
  margin-right: 0px;
  margin-top: 4px;
  height: 20px;
  min-width: 26px !important;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const StyledActionIcon = styled(Icon)`
  color: #999;
  &:hover {
    cursor: pointer;
  }
`;

const Menu = styled.div`
`;

const MenuItem = styled.div`
  cursor: pointer;
  padding: 4px 12px;
  &:hover {
    color: white;
    background-color: #999;
  }
`;

const ActionButton = ({ actions = [], dataTestId = 'action-button' }) => {
  const menu = <Menu data-test-id={`${dataTestId}-menu`}>
    {actions?.map((a, i) =>
      <MenuItem key={i} onClick={a.onClick} data-test-id={`${dataTestId}-action-${i + 1}`}>
        {a.text}
      </MenuItem>,
    )}
  </Menu>;

  if (!actions?.length) {
    return null;
  }

  return (
    <Popover
      content={menu}
      overlayClassName='action-menu-overlay'
      placement='bottomRight'
    >
      <LinkActions data-test-id={dataTestId}>
        <StyledActionIcon type='ellipsis-h' solid={true} size='sm' />
      </LinkActions>
    </Popover>
  );
};

ActionButton.propTypes = {
  actions: PropTypes.array,
  dataTestId: PropTypes.string,
};

export default ActionButton;
